// extracted by mini-css-extract-plugin
export default {"main":"Addresses_main__dP8lk","container":"Addresses_container__Oz-go"};